import React from "react";
import { FormControl, FormGroup, FormLabel } from "@mui/material";
import { Button } from "@chemaxon/design-system/button";
import { Checkbox } from "@chemaxon/design-system/checkbox";
import { FormControlLabel } from "@chemaxon/design-system/form";

import ViewContainer from "@chemaxon/terminus-client/ui/components/view-container/ViewContainer";
import NotificationSettingsService from "@chemaxon/terminus-client/ui/services/NotificationSettingsService";
import Subheader from "@chemaxon/terminus-client/ui/components/subheader/Subheader";
import FormHeader from "@chemaxon/terminus-client/ui/components/form/FormHeader";
import FormActions from "@chemaxon/terminus-client/ui/components/form/FormActions";
import FormLayoutVertical from "@chemaxon/terminus-client/ui/components/form/FormLayoutVertical";

class NotificationSettingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationSettings: [],
    };
    NotificationSettingsService.getNotificationSettings().then(value => {
      this.setState({
        notificationSettings: value,
      });
    });
  }

  handleChange = event => {
    const newNotificationSettings = this.state.notificationSettings.map(
      notification => {
        if (notification.type === event.target.name) {
          notification.unsubscribed = !event.target.checked;
        }
        return notification;
      },
    );
    this.setState({
      notificationSettings: newNotificationSettings,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const unsubscribed = this.state.notificationSettings.map(notification => {
      return {
        type: notification.type,
        unsubscribed: notification.unsubscribed ? true : false,
      };
    });
    NotificationSettingsService.updateNotificationSettings(unsubscribed);
  };

  render() {
    return (
      <React.Fragment>
        <Subheader title="Notification settings" />
        <ViewContainer id={"notificationSettings"}>
          <form onSubmit={this.handleSubmit} id="notificationSettings">
            <FormLayoutVertical>
              <FormHeader title="Events" />

              <FormControl>
                <FormLabel>Send me email when:</FormLabel>
                <FormGroup>
                  {this.state.notificationSettings.map(notification => (
                    <FormControlLabel
                      key={notification.type}
                      control={
                        <Checkbox
                          checked={!notification.unsubscribed}
                          onChange={this.handleChange}
                          name={notification.type}
                        />
                      }
                      label={notification.preferencesLabel}
                    />
                  ))}
                </FormGroup>
              </FormControl>

              <FormActions>
                <Button
                  colorVariant="primary"
                  className="submit-update-notification-settings"
                  type="submit"
                >
                  Update my preferences
                </Button>
              </FormActions>
            </FormLayoutVertical>
          </form>
        </ViewContainer>
      </React.Fragment>
    );
  }
}

export default NotificationSettingsView;
